import { SimpleBars } from '../../../Common/Charts/SimpleBars';
import { useDatabaseChartsDataContext } from './hooks/useDatabaseChartsDataContext';

export const BolsaFamiliaReceiving = () => {
    const { chartData } = useDatabaseChartsDataContext();


    return (
        <SimpleBars
            title={'Recebimento de Bolsa Família'}
            horizontal={true}
            subtitles={chartData?.bolsaFamilia?.map((item) => item.description)}
            values={chartData?.bolsaFamilia?.map((item) => item.total  ||  0)}
            className='aligned-container'
        />
    );
};
